import styles from "./styles.module.scss";

interface ProgressArrowProps {
  size?: number;
  isComplete?: boolean;
  isFirst?: boolean;
  spacerColor?: string;
  imageUrl?: string;
}

const ProgressArrow: React.FC<ProgressArrowProps> = ({
  size = 130,
  isComplete,
  isFirst,
  spacerColor,
  imageUrl,
}) => {
  const width = size;
  const height = size * 0.55;
  return (
    <div className={styles.container} style={{ width, height }}>
      {imageUrl && (
        <img
          className={styles.iconImage}
          style={{ left: isFirst ? "40%" : undefined }}
          src={imageUrl}
          alt=""
        />
      )}
      <div
        className={`${styles.arrow} ${!isFirst ? styles.nextArrow : ""} ${
          !isComplete ? styles.secArrow : ""
        }`}>
        <div
          className={`${spacerColor === "primary" ? styles.primary : ""}`}
          style={{
            backgroundColor:
              spacerColor === "primary" ? undefined : spacerColor,
          }}></div>
        <div></div>
        <div></div>
      </div>
    </div>
  );
};

export default ProgressArrow;
